import loadGoogleMaps, {
  createGoogleMapsImageMarker,
  getGoogleMapsApiKey
} from '../../js/modules/google-maps-loader'
import mapStyles from '../../js/search-app/mapStyles.json'
import { getMetaValue } from '../../js/modules/helper-functions'

export const settings = {
  selector: '.js-location-highlights__map',
  placeTypes: [
    'subway_station',
    'train_station',
    'bus_station',
    'restaurant',
  ]
}

const GOOGLE_MAPS_API_KEY = getGoogleMapsApiKey()

/**
 * Function initializes all elements in page.
 */
export default function initAll() {
  let elements = document.querySelectorAll( settings.selector )
  Array.from( elements ).forEach(() => {
    init()
  })
}

/**
 * Returns the icon url for the place.
 *
 * @param {object} place
 */
function getPlaceIconUrl( place ) {
  const styleDir = getMetaValue( 'wp-stylesheet-directory-uri' )
  const intersection = settings.placeTypes.filter(( type ) => -1 !== place.types.indexOf( type ))
  switch ( intersection.shift()) {
    case 'train_station':
      return `${styleDir}/assets/src/img/icons/png/white/train.png`
    case 'bus_station':
      return `${styleDir}/assets/src/img/icons/png/white/bus.png`
    case 'subway_station':
      return `${styleDir}/assets/src/img/icons/png/white/metro.png`
    case 'restaurant':
      return `${styleDir}/assets/src/img/icons/png/white/restaurant.png`
    default:
      return place.icon
  }
}

/**
 * Function initializes the location highlight map.
 */
function init() {
  var maps, map

  /**
   * Create a marker on the map.
   * @param {PlaceResult} place
   */
  function createMarker( place ) {
    createGoogleMapsImageMarker( maps, {
      map: map,
      title: place.name,
      position: place.geometry.location,
      src: getPlaceIconUrl( place ),
      size: 25
    })
  }

  /**
   * Function initializes single element.
   * @param {Array<PlaceResult>} results
   * @param {PlaceServiceStatus} status
   */
  function callback( results, status ) {
    if ( status == maps.places.PlacesServiceStatus.OK ) {
      for ( var i = 0; i < results.length; i++ ) {
        createMarker( results[i])
      }
    }
  }

  loadGoogleMaps({ key: GOOGLE_MAPS_API_KEY, libraries: [ 'places' ]})
    .then(( googleMaps ) => {

      maps = googleMaps

      const container = document.querySelector( settings.selector )
      const lat = container.dataset.lat
      const lng = container.dataset.lng
      const pos = new maps.LatLng( lat, lng )
      const args = {
        zoom: 16,
        styles: mapStyles,
        mapTypeControl: false,
        streetViewControl: false,
        center: pos
      }

      map = new maps.Map( container, args )

      const styleDir = getMetaValue( 'wp-stylesheet-directory-uri' )
      const pin = `${styleDir}/assets/src/img/icons/png/green/location.png`

      createGoogleMapsImageMarker( maps, {
        position: pos,
        map: map,
        src: pin,
        size: 36
      })

      const places = container.dataset.places
      // Use server side fetched data if available.
      if ( places ) {
        const places_object = JSON.parse( places )
        for ( const key in places_object ) {
          callback( places_object[ key ], maps.places.PlacesServiceStatus.OK )
        }
      } else {
        const placeService = new maps.places.PlacesService( map )

        for ( const type of settings.placeTypes ) {
          var request = {
            location: pos,
            radius: '750',
            type: type
          }
          placeService.nearbySearch( request, callback )
        }
      }
      return googleMaps
    })
}
